import { PropsWithChildren } from 'react'

import { GameId } from '@common'
import cx from 'classnames'

import styles from './ItemsGrid.module.scss'

type GridProps = PropsWithChildren<{
  gameId: GameId
  className?: string
}>

export const Grid = ({ children, gameId, className }: GridProps) => (
  <div className={cx(styles.Items, styles[gameId], className)}>{children}</div>
)
